import Vue from 'vue';

import VueRouter from 'vue-router';
import ViewSelect from '../components/ViewSelect.vue';
import SalesPerformance from '../components/SalesPerformance/SalesPerformance.vue';
import BranchSale from '../components/Branch/BranchSale.vue';
import ItemPromotion from '../components/Item/ItemPromotion.vue';
import MainSale from '../components/Branch/MainSale.vue';
import LoginForm from '../components/LoginForm.vue';
import CarouselView from '../components/Other/CarouselView.vue';

// 使用 VueRouter
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/login-form'
    },
    {
        path: '/view-select',
        name: 'ViewSelect',
        component: ViewSelect
    },
    {
        path: '/sales-performance',
        name: 'SalesPerformance',
        component: SalesPerformance
    },
    {
        path: '/branch-sale',
        name: 'BranchSale',
        component: BranchSale
    },
    {
        path: '/item-promotion',
        name: 'ItemPromotion',
        component: ItemPromotion
    },
    {
        path: '/main-sale',
        name: 'MainSale',
        component: MainSale
    },
    {
        path: '/login-form',
        name: 'LoginForm',
        component: LoginForm
    },
    {
        path: '/carousel-view', // 轮播图组件示例页面路由路径，根据实际情况修改路径名和组件名
        name: 'CarouselView',
        component: CarouselView 
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;
